export default __webpack_public_path__ + "static/media/header.c92cd8d5.png";